/**
 * Remembers the last Track page you had open in your own library — its full
 * URL, so the tab, filters, sort, search and view come back with it — so
 * returning to Track (the drawer link, or /track) picks up where you left off,
 * as switching between sections of an app does.
 *
 * Kept in sessionStorage: it survives navigating around and reloading, but a
 * fresh session (the app closed and reopened) starts from your defaults rather
 * than a forgotten set of filters. Keyed by username, so another account
 * signed in on the same device never lands on yours. Storage can be
 * unavailable (private mode, blocked site data), so every access is guarded.
 */
const storageKey = (username) => `lastTrackPath:${username}`;

export const getLastTrackPath = (username) => {
  try {
    const path = sessionStorage.getItem(storageKey(username));
    // Only ever a page within your own library
    return path?.startsWith(`/track/u/${username}/`) ? path : null;
  } catch {
    return null;
  }
};

export const setLastTrackPath = (username, path) => {
  try {
    sessionStorage.setItem(storageKey(username), path);
  } catch {
    // Not remembered — returning to Track just starts from the defaults
  }
};

export const clearLastTrackPath = (username) => {
  try {
    sessionStorage.removeItem(storageKey(username));
  } catch {
    // Nothing stored to clear
  }
};
